module.exports = __webpack_public_path__ + "media/images/logos/rpf-logo-small-38a0f151aa21a48b52055700b1f425e0.svg";